<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-header-title"
     mat-dialog-title>
    <div cdkDragHandle class="title">
      <span [innerHTML]="title | translate"></span>
      <div class="handle"></div>
    </div>
    <span class="close-modal" mat-dialog-close>
        <mat-icon >close</mat-icon>
    </span>
</div>
